import { useContext } from 'react'
import { CollectionContext } from '../../state/CollectionContext'
import globalStyle from '../../styles/common.module.css'
import style from './article.module.css'

export function ReviewArticle() {
  const context = useContext(CollectionContext)
  const story = context.state.find((story) => story.isActive)
  if (!story) return null

  return (
    <div className={[globalStyle.grid6].join(' ')}>
      {
        story.content.map((section, i) => {
          return (
            <p key={`review-p${i}`} className={[globalStyle.bodyLG, style.chunks].join(' ')}>
              {
                section.map((chunk, j) => {
                  const isSelectable = chunk.userComment || chunk.voxComment
                  return (
                    <span key={`review-${j}${i}`}>
                      <span
                        onClick={() =>
                          context.dispatch({ type: 'select_chunk', chunkId: chunk.id })
                        }
                        tabIndex={isSelectable ? 0 : -1}
                        onKeyDown={(e) => {
                          if (e.key === 'Enter' || e.key === ' ') {
                            e.preventDefault()
                            context.dispatch({ type: 'select_chunk', chunkId: chunk.id })
                          }
                        }}
                        className={
                          isSelectable
                            ? [
                                globalStyle.iconText,
                                style.selected,
                                chunk.isSelected ? style.active : '',
                              ].join(' ')
                            : ''
                        }
                      >
                        {chunk.userComment && chunk.voxComment ? (
                          <img src='assets/icons/common-edit.svg' alt='common edit icon' />
                        ) : chunk.userComment ? (
                          <img src='assets/icons/editing.svg' alt='common edit icon' />
                        ) : chunk.voxComment ? (
                          <img src='assets/icons/lp-logo.svg' alt='common edit icon' />
                        ) : null}
                        {chunk.italic ? <i>{chunk.text}</i> : chunk.text}
                      </span>
                      <span>{chunk.trailing}</span>
                    </span>
                  )
                })
              }
            </p>
          )
        })
      }
    </div>
  )
}

